import Modal from "../components/payment/modal";
import SuccessMessage from "../components/payment/SuccessMessage/SuccessMessage";
import { useAuth } from "../context/AuthContext";
import { dictionary } from "../utils/dictionary";
import { ButtonFluxi } from "../components/common/Buttons/ButtonFluxi/ButtonFluxi";
import { useNavigate } from "react-router-dom";

const SuccessPage = () => {
  const { language } = useAuth();
  const navigate = useNavigate();

  return (
    <Modal onClose={() => {}} navigationPath="/">
      <SuccessMessage message={dictionary["congratulations"][language]} description={dictionary["plan-updated"][language]} />
      <div style={{ display: "flex", justifyContent: "center", gap: 16 }}>
        <ButtonFluxi text={dictionary["next"][language]} onClick={() => {
          navigate("/home");
        }} />
      </div>
    </Modal>
  );
};

export default SuccessPage;
